import Invoice3Container from "../../../../../Components/Applications/ECommerce/Invoice/Invoice3/Invoice3Container";

const Invoice3 = () => {
  return <Invoice3Container />;
};

export default Invoice3;
